module.exports = __webpack_public_path__ + "media/images/locations/circle/germany-fad60791629dc96a8efb69d55dcfa4c8.jpg";